'use strict';

app.service('rmGuide', function ($window, $location) {
  var key = function (id) {
    return $location.host() + '.tutorial.' + id;
  };
  this.isViewed = function (id) {
    return !!$window.localStorage.getItem(key(id));
  };
  this.markViewed = function (id) {
    return $window.localStorage.setItem(key(id), 'true');
  };
});

app.directive('rmGuide', function () {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      icon: '=',
      tutorial: '=rmGuide',
      onNotificationDismiss: '&',
      isOpen: '='
    },
    templateUrl: '/app/directives/rm-guide/rm-guide.html',
    link: function (scope, el) {
      scope.iconLoaded = false;
      var img = new Image();
      img.onload = function () {
        scope.$apply(function () {
          scope.iconLoaded = true;
        });
      };
      img.src = scope.icon;

      scope.notification = {
        isOpen: angular.isDefined(scope.isOpen) ? scope.isOpen : true
      };
      scope.docked = !scope.notification.isOpen;
      scope.dismissNotification = function () {
        scope.docked = true;
        $(el).find('.rm-guide-notification, .rm-guide-notification-arrow')
          .addClass('exit-animation')
          .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $(this).removeClass('exit-animation');
            scope.$apply(function () {
              scope.notification.isOpen = false;
            });
          });
        scope.onNotificationDismiss(scope.tutorial);
      };
      scope.open = function () {
        if (scope.notification.isOpen) {
          return;
        }
        $(el).find('.rm-guide-notification, .rm-guide-notification-arrow')
          .addClass('enter-animation')
          .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $(this).removeClass('enter-animation');
          });
        scope.notification.isOpen = true;
      };

      scope.toggleIcon = function () {
        scope.docked = !scope.docked;
        if (!scope.docked) {
          scope.open();
        } else {
          scope.notification.isOpen = false;
        }
      };
    }
  };
});
